import { DateTime } from "luxon";

export const defaultLocale = "en-US"; // "ko-KR"; // "es-ES"; //
export const defaultTimeZone = "US/Mountain";

export const getStartOfDay = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let startOfDay = dateTime.setZone(timezone).startOf("day").toJSDate();
  return startOfDay;
};

export const getEndOfDay = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let endOfDay = dateTime.setZone(timezone).endOf("day").toJSDate();
  return endOfDay;
};

export const getStartOfDayBefore = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let startOfDayBefore = dateTime.setZone(timezone).minus({ days: 1 }).startOf("day").toJSDate();
  return startOfDayBefore;
};

export const getEndOfDayBefore = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let endOfDayBefore = dateTime.setZone(timezone).minus({ days: 1 }).endOf("day").toJSDate();
  return endOfDayBefore;
};

export const getStartOfWeek = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let startOfWeek = dateTime.setZone(timezone).startOf("week").toJSDate();
  return startOfWeek;
};

export const getEndOfWeek = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let endOfWeek = dateTime.setZone(timezone).endOf("week").toJSDate();
  return endOfWeek;
};

export const getStartOfPreviousWeek = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let startOfPreviousWeek = dateTime.setZone(timezone).minus({ weeks: 1 }).startOf("week").toJSDate();
  return startOfPreviousWeek;
};

export const getEndOfPreviousWeek = (date, timezone = defaultTimeZone) => {
  let dateTime = DateTime.fromJSDate(date);
  let endOfPreviousWeek = dateTime.setZone(timezone).minus({ weeks: 1 }).endOf("week").toJSDate();
  return endOfPreviousWeek;
};

export const formatDateToUtc = (date) => {
  return date.toISOString();
};

export const formatDateToLocale = (date, locale = defaultLocale) => {
  try {
    return date.toLocaleDateString(locale);
  } catch (err) {
    console.error("Error in formatDateToLocale", err);
    console.error("Error in formatDateToLocale: Locale", locale);
    return date.toLocaleDateString("en-US");
  }
};

export const formatTimeToLocale = (date, locale = defaultLocale) => {
  try {
    return date.toLocaleTimeString(locale);
  } catch (err) {
    console.error("Error in formatDateToLocale", err);
    console.error("Error in formatDateToLocale: Locale", locale);
    return date.toLocaleDateString("en-US");
  }
};

export const formatDateTimeToLocale = (date, locale = defaultLocale) => {
  try {
    return date.toLocaleString(locale);
  } catch (err) {
    console.error("Error in formatDateToLocale", err);
    console.error("Error in formatDateToLocale: Locale", locale);
    return date.toLocaleDateString("en-US");
  }
};
